import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import Home from "./routes/Home";
import Unit from "./routes/Unit";
import CourseFlow from "./routes/CourseFlow";
import CoursePlan from "./routes/CoursePlan";
import TimetablePlanner from "TimetablePlanner";
import Class from "./routes/Class";
import CourseSettings from "./routes/CourseSettings";
import SubjectSettings from "./routes/SubjectSettings";
import ClassSettingsV2 from "Course/routes/ClassSettingsV2";
import AssessmentToolsSetup from "./routes/AssessmentToolsSetup";
import CourseStandards from "./routes/CourseStandards";
import SymLinks from "Platform/routes/SymLinks";
import LtiTools from "./routes/LTITool";
import AssociatedCourses from "./routes/AssociatedCourses";
import AssociatedCoursesV2 from "./routes/AssociatedCoursesV2";

export default store => ({
  path: "learning-course/:learningCourseId",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "learning-course" */ "./components"),
      import(
        /* webpackChunkName: "learning-course" */ "./modules/LearningCourseModule"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const reducer = importedModule1.default;

      if (reducer) {
        injectReducer(store, {
          key: "learningCourse",
          reducer,
        });
      }

      return component;
    })
  ),
  childRoutes: [
    SymLinks(store),
    Home(store),
    Unit(store),
    CourseStandards(store),
    CourseFlow(store),
    CoursePlan(store),
    TimetablePlanner(store),
    AssessmentToolsSetup(store),
    Class(store),
    CourseSettings(store),
    SubjectSettings(store),
    ClassSettingsV2(store, true),
    LtiTools(store),
    AssociatedCourses(store),
    AssociatedCoursesV2(store),
  ],
});
